export const QUATERLY_DATA = {
   QUATERLY_DATA_LOAD: "QUATERLY_DATA_LOAD",
   QUATERLY_DATA_SUCCESS: "QUATERLY_DATA_SUCCESS",
   QUATERLY_DATA_FAIL: "QUATERLY_DATA_FAIL"
}

export const QUATERLY_API = 'https://0sylzdpaf7.execute-api.us-east-1.amazonaws.com/test/mds_vmo' 
//'https://0sylzdpaf7.execute-api.us-east-1.amazonaws.com/test/mdstestqueue'